import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import updateGlobalModeSite from './middleware/updateGlobalModeSite';
import { useDispatch } from 'react-redux';
// reducers
import dashboard from 'pages/dashboard/controllers/dashboardReducer';
import searchEntity from 'pages/common/SearchEntity/controllers/Reducer';
import searchPage from 'pages/searchPage/controllers/searchPageReducer';
import overallalerts from 'pages/alertPage/controllers/alertsPageReducer';
import remediation from 'common/Components/Remediation/controllers/remediationReducer';
import advancedSearch from 'pages/common/AdvancedSearch/controllers/Reducer';
import objectsPage from 'pages/objectPage/controllers/objectsPageReducer';
import actionsPage from 'pages/actionsPage/controllers/reducer';
import scannerPage from 'pages/ScannerPage/controllers/scannerPageReducer';
import settings from 'pages/settingsPage/controllers/reducer';
import reports from 'pages/reportPage/controllers/Reducer';
import masterSlave from 'common/Components/MasterSlave/controllers/reducer';
import userManagement from 'common/Components/UserManagement/controllers/reducer';
import supportedHosts from 'common/Components/SupportedHosts/controllers/reducer';
import mapPage from 'pages/mapPage/controllers/mapPageReducer';
import auditPage from 'pages/auditPage/controllers/auditReducer';
import fileMonitoringReducer from 'pages/searchPage/components/FileMonitoring/controllers/FileMonitoringReducer';
import WindowsEventsReducer from 'pages/searchPage/components/WindowsEvents/controller/WindowsEventsReducer';
import ArpReducer from 'pages/searchPage/components/SystemOverview/components/TabsContent/Arp/controller/ArpReducer';
import InstalledSoftwareReducer from 'pages/searchPage/components/SystemOverview/components/TabsContent/InstalledSoftware/controller/InstalledSoftwareReducer';
import SharesReducer from 'pages/searchPage/components/SystemOverview/components/TabsContent/Shares/controller/SharesReducer';
import DeviceControlReducer from 'pages/searchPage/components/SystemOverview/components/TabsContent/DeviceControl/controller/DeviceControlReducer';
import OverlayReducer from 'common/Overlay/reducer';
import clientSitesActions from 'globalPages/settingsPage/controllers/clientSitesActionsSearchReducer';
import userReducer from './slices/userSlice';
import groupSettingsReducer from './slices/groupSettings';
import allInOneScanGroupsReducer from './slices/allInOneScanGroup/allInOneScanGroupSlice';
import appIntegrationReducer from './slices/appIntegration/appIntegrationSlice';
import alertsReducer from './slices/alerts';
import siteSliceReducer from './slices/site';

const combinedReducer = combineReducers({
  dashboard,
  scannerPage,
  searchPage,
  searchEntity,
  overallalerts,
  remediation,
  advancedSearch,
  objectsPage,
  actionsPage,
  settings,
  reports,
  masterSlave,
  userManagement,
  supportedHosts,
  mapPage,
  auditPage,
  fileMonitoringReducer,
  WindowsEventsReducer,
  ArpReducer,
  InstalledSoftwareReducer,
  SharesReducer,
  DeviceControlReducer,
  clientSitesActions,
  OverlayReducer,
  user: userReducer,
  groupSettings: groupSettingsReducer,
  allInOneScanGroupsReducer,
  appIntegration: appIntegrationReducer,
  alerts: alertsReducer,
  site: siteSliceReducer
});

export const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_STORE') {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  devTools: {
    name: 'Cynet'
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['settings.quickWhiteListingProfile']
      }
    }).concat(updateGlobalModeSite)
});

export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
